module.exports = __webpack_public_path__ + "static/media/income_other.ad79f61e.svg";